import React from 'react';
import MainHeader, { MENU_WOOD_IMPORT } from '../components/common/MainHeader';
import { Media } from "../AppMedia";
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { PATH } from '../routes/Routes';
import WoodImportList from '../components/wood-import/WoodImportList';
import WoodImportMobileList from '../components/wood-import/mobile/WoodImportMobileList';
import Cookies from 'js-cookie';
import { Button, Layout, Typography } from "antd";
import { PlusOutlined } from '@ant-design/icons';
import { Content } from 'antd/es/layout/layout';
import ColorButton from '../components/common/ColorButton';
import { GREEN } from '../constance/color';


export default function WoodImportListView() {

	const { Title } = Typography;
	const { t } = useTranslation();
	const history = useHistory();
	const [user] = React.useState(JSON.parse(Cookies.get('user', {})));

	return (
		<div>
			<MainHeader activeItem={MENU_WOOD_IMPORT} />
			<Layout>
				<Content style={{ margin: '24px', marginTop: '7em' }}>
					<Title level={2}>{t('menus.wood_menus.wood_import')}</Title>
					{user.groups && user.groups.length > 0 && user.groups.includes('officer') &&
						<div style={{ textAlign: 'right', marginBottom: 12 }}>
							<ColorButton
								type="primary"
								icon={<PlusOutlined />}
								override={GREEN}
								onClick={() => history.push(`${PATH.WOOD_IMPORT}add/`)}>
								{t('wood_imports.add')}
							</ColorButton>
						</div>
					}
					<Media lessThan={"md"}>
						<WoodImportMobileList />
					</Media>

					<Media greaterThanOrEqual="md">
						<WoodImportList />
					</Media>
				</Content>
			</Layout>
		</div>
	);
}